import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';

const ProductFeatures = ({ features }) => (
  <div className="mt-9">
    <div className="text-[11px] tracking-[0.28em] text-accent font-medium mb-5">OZELLIKLER</div>
    <div className="grid sm:grid-cols-2 gap-3">
      {features.map((feature) => (
        <div key={feature} className="flex items-center gap-3 text-[14px] text-white/80">
          <span className="w-6 h-6 rounded-full bg-primary/15 border border-primary/40 flex items-center justify-center shrink-0"><Check size={12} className="text-accent" /></span>
          {feature}
        </div>
      ))}
    </div>
  </div>
);

export const ProductInfo = ({ product, hasRelated }) => (
  <div className="min-w-0">
    <div className="flex items-center gap-3 mb-5"><span className="h-px w-10 bg-clay" /><span className="text-[11px] tracking-[0.28em] text-clay font-medium">URUN DETAYI</span></div>
    <h1 data-testid="product-title" className="text-[36px] sm:text-[44px] lg:text-[52px] leading-[1.1] font-semibold text-white break-words">{product.title}</h1>
    <p className="mt-6 text-[15.5px] text-white/65 leading-[1.8]">{product.longDescription}</p>
    <ProductFeatures features={product.features} />
    <div className="mt-10 flex flex-wrap gap-3">
      <Link data-testid="product-quote-link" to="/iletisim" className="inline-flex items-center gap-3 px-7 py-4 rounded-full bg-gradient-to-b from-primary to-primary-hover text-primary-foreground text-[12px] font-semibold tracking-[0.2em] hover:from-primary-hover hover:to-primary-hover transition-all duration-300 shadow-lg shadow-primary/20 hover:-translate-y-0.5 group">
        FIYAT TEKLIFI ALIN <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
      </Link>
      {hasRelated && <a data-testid="product-related-projects-link" href="#related" className="inline-flex items-center gap-3 px-7 py-4 rounded-full border border-white/20 text-white text-[12px] font-semibold tracking-[0.2em] hover:bg-white/5 hover:border-white/40 transition-colors duration-300">ORNEK PROJELERI GOR</a>}
    </div>
  </div>
);